import React,{useState} from 'react';

// tag input
import { WithContext as ReactTags } from 'react-tag-input';
import '../common/Util/TagStyle.css';

// http axios
import axios from 'axios';
import axiosUrl from '../../axios/url';
 
// custom function
import ContentsHeader from './ContentsHeader';
import ImageUploader from '../common/Util/ImageUploader';

import SurveyModal from './modal/SurveyModal';

export default function SurveysModify(param) {

    const [surveyList, setsurveyList] = useState([{
                                                question: "", 
                                                answerType : "SELECTION", 
                                                selectionType: "SINGLE",
                                                items : [] //[{body: "", tags: [], relatedTags: ""}] body == anwers
                                             }]);
    const [surveyNumber, setsurveyNumber] = useState('');
    const [title, setTitle] = React.useState('');
    const [opened, setOpened] = React.useState(false);
    const [thumbFile, setThumbFile] = React.useState('');
    const [oldThumbImage, setOldThumbImage] = React.useState();
    const [reference, setReference] = React.useState('');
    const [keywordTags, setKeywordTags] = useState([]);
    const [check, setCheck] = useState(true);
    const [relatedTagCheck, setRelatedTagCheck] = useState(false);
    const [relatedTagCheckCss, setRelatedTagCheckCss] = useState("mt-2 d-none")
    const [surveyId, setSurveyId] = useState();
    const [sendData, setSendData] = useState([]);

    //----- onchange event setting start
    function onChangeTitle(e){  setTitle(e.target.value); }

    // 공개여부 변경
    function onChangeOpened(e){ setOpened(e.target.checked);}

    // 검색어 태그 삭제
    function handleKeywordDelete(i) {  setKeywordTags(keywordTags.filter((tag, index) => index !== i)); }

    // 검색어 태그 추가
    function handleKeywordAddition(tag) {  setKeywordTags([...keywordTags, {id :tag.text, text:tag.text}]); }

    // 참고문헌 변경
    function onChangeReference(e){  setReference(e.target.value); }

    function surveyNumberCheck(i) {
        setsurveyNumber(i);
    }

    function surveyAdd() {
        var temp = surveyList;
        temp.push({
            question: "", 
            answerType : "SELECTION", 
            selectionType: "SINGLE",
            items : [],
         });
        setsurveyList(temp);
        setCheck(!check)
    }

    function surveyDelete(i) {
        var temp = surveyList;
        temp.splice(i, 1);
        setsurveyList(temp);
        setCheck(!check);
    }

    function questionChange(i, value) {
        surveyList[i].question = value;
        setCheck(!check);
    }

    function answerTypeChange(i, value) {
        surveyList[i].answerType = value;
        surveyList[i].answers = [];
        surveyList[i].items = [];
        if(value == "TEXT") {
            surveyList[i].selectionType = "NONE";
        }
        setCheck(!check);
    }

    function selectionTypeChange(i, value) {
        surveyList[i].selectionType = value;
        setCheck(!check);
    }

    function relatedTagCheckChange() {
        setRelatedTagCheck(!relatedTagCheck);
        if(!relatedTagCheck == true){
            setRelatedTagCheckCss("mt-2");
        } else {
            setRelatedTagCheckCss("mt-2 d-none");
        };
    }

    function answerAdd(i) {
        var temp = surveyList[i].items;
        temp.push({body: "", tags: [], relatedTags: []});
        setCheck(!check);
    }
    
    function answerChange(i, j, value) {
        surveyList[i].items[j].body = value;
        setCheck(!check);
    }

    function answerdelete(i, j) {
        var temp = surveyList[i].items;
        temp.splice(j, 1);
        setCheck(!check);
    }

    function itemDeleteTag(i, j, e) {
        var temp = surveyList[i].items[j].relatedTags;
        temp.splice(e, 1);
        setCheck(!check);
    }
    
    function itemAddTag(i, j, tag) {
        var temp = surveyList[i].items[j].relatedTags;
        temp.push(tag)
        setCheck(!check);
    }

    function onChangeThumbFile(imageFile){
        var formData = new FormData();
        formData.append('file', imageFile[0])
        return axios.post(axiosUrl.fileupload, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Max-Age': '3600',
              'Access-Control-Allow-Headers': 'Origin,Accept,X-Requested-With,Content-Type,Access-Control-Request-Method,Access-Control-Request-Headers,Authorization'
            }
          }).then(res => {
            console.log('[MEDIEX_CMS_2019_LOGGING] BlogsCreate.onChangeThumbFile SUCCESS');
            setThumbFile(res.data.filename);
          }).catch( e => {
            console.error('[MEDIEX_CMS_2019_ERROR] BlogsCreate.onChangeThumbFile - ' + e);
          })
    }
    React.useEffect(() => {
    }, check);

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }

    async function updateSurvey(e){
        if(trim(title) === ''){ alert('제목을 확인하세요.'); return;}
        var list = [];
        surveyList.map((survey, surveyOrder) => {
            var items = [];
            var temp = {};
            if(survey.selectionType !== "TEXT") {
                survey.items.map((item, i) => {
                    var tagString = "" ;
                    item.relatedTags.map((tag, i) => {
                        if( i === 0) {
                            tagString = tagString + tag.text;
                        } else {
                            tagString = tagString +","+ tag.text;
                        }
                    })
                    items.push({body: item.body, relatedTags: tagString, order: i+1});
                })
                temp = {
                    question: survey.question,
                    answerType: survey.answerType,
                    selectionType: survey.selectionType,
                    order: surveyOrder+1,
                    items: items
                }
            } else {
                temp = {
                    question: survey.question,
                    answerType: survey.answerType,
                    selectionType: survey.selectionType,
                    order: surveyOrder+1
                }
            }  
            list.push(temp);
        })

        var tagString = "" ;
        keywordTags.map((tag, i) => {
            if( i === 0) {
                tagString = tagString + tag.text;
            } else {
                tagString = tagString +","+ tag.text;
            }
        })

        var sendData = {
            type: "Survey",
            title: title,
            keyword: tagString,
            reference: reference,
            thumbnailUrl: thumbFile,
            opened: opened,
            surveys: list
        }
    //    console.log(sendData);
        var url = axiosUrl.surveys+"/"+surveyId;  
        await axios.put(url,sendData)
        .then(function (response){
            alert('설문 추가되었습니다.');
            goList(e); 
         })
        .catch(function (e) {
            alert('설문 등록에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] - ' + e.response.data.error.message);
        });
    }

    // 정보 가져오기
    async function getSurey(id){
        var url = axiosUrl.surveys + '/' + id;
        await axios.get(url)
        .then( res => {
           setTitle(res.data.title);
           setOpened(res.data.opened);
           //미리보기 이미지 때문에 추가
           var tempList = [];
           res.data.surveys.map((quiz) => {
               //퀴즈 당 보기 리스트
               var items = [];
               quiz.items.map((item) => {
                    // items.push(item.body);
                    // keyword 데이터 타입 맞추기
                    if(res.data.keyword !== '[]'){

                        const resultArr = res.data.keyword .split(",");
                        const tagArr = [];
                        resultArr.map((tagName, i) => {
                            tagArr.push({id: tagName, text: tagName});
                        })
                        item.relatedTags = tagArr;
                    }else{
                        item.relatedTags = [];
                    }
               })
               //설문 문제
               var temp = {
                    question: quiz.question, 
                    answerType : quiz.answerType, 
                    selectionType: quiz.selectionType, 
                    items : quiz.items
               }
               //설문 보기 리스트
               tempList.push(temp);
           })
           setsurveyList(tempList);

           // keyword 데이터 타입 맞추기
           if(res.data.keyword !== ''){

                const resultArr = res.data.keyword .split(",");
                const tagArr = [];
                resultArr.map((tagName, i) => {
                    tagArr.push({id: tagName, text: tagName});
                })
                setKeywordTags(tagArr);
            }else{
                setKeywordTags([]);
            }
           
           setReference(res.data.reference);
           setThumbFile(res.data.thumbnailUrl);
           setOldThumbImage(res.data.thumbnailUrl);
           setCheck(!check);
        })
        .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] ProgramEditDialog.getProgram - ' + e);
        });
    }
    
    async function deleteSurvey(e){
        if(!window.confirm('해당 설문을 삭제하시겠습니까?')) return;

        var url = axiosUrl.surveys + '/' + surveyId;
        await axios.delete(url)
        .then(function (response){ 
            alert('설문이 삭제되었습니다.');
            goList(); 
        })
        .catch(function (e) {
            alert('설문 삭제에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] blogsmodify.deleteContent - ' + e);
        });
    }

    function goList(e){
        window.location = '/contents/surveys';
    }

    function preViewSurvey() {
        setSendData(surveyList);
    }

    //미리 보기 초기화
    function callbackSurveySendData() {
        setSendData([]);
    }

    React.useEffect(() => {
        setSurveyId(param.match.params.id);
        getSurey(param.match.params.id);
    },[param.match.params.id]);

    return(
        <div >
            <div className="content-wrapper">
                <ContentsHeader  />
                <section className="content" >
                    <div className="row">
                         <div className="col-12">
                            <button  className="btn float-right" type="button" onClick={surveyAdd}>
                                <h3 className="card-title"><i className="fas fa-plus mr-1"></i> 설문 추가 </h3>
                            </button>
                        </div>
                        <div className="col-6">
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">기본정보</h3>
                                </div>
                                <div className="card-body">
                                    <h3 className="card-title">제목</h3>
                                    <input type="text" className="form-control" id="title11" placeholder="제목을 입력하세요.." onChange={onChangeTitle} value={title}/>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">썸네일</h3>
                                </div>
                                <div className="card-body">
                                    {
                                        oldThumbImage !== '' && <div className="card-body text-center mb-0"><img src={oldThumbImage} width="150" height="150"/></div>
                                    }
                                    <ImageUploader callbackImage={onChangeThumbFile} />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">검색어</h3>
                                </div>
                                <div className="card-body">
                                    <ReactTags id="keywordTag"
                                        tags={keywordTags}
                                        placeholder='검색어'
                                        handleDelete={handleKeywordDelete}
                                        handleAddition={handleKeywordAddition}
                                        autofocus={false}
                                        readOnly={false}
                                    />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">참고문헌</h3>
                                </div>
                                <div className="card-body">
                                    <input type="text" className="form-control" id="title" placeholder="내용을 입력하세요.." onChange={onChangeReference} value={reference}/>
                                </div>
                            </div>
                            <div className="card card-danger">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">공개여부</h3>
                                </div>
                                <div className="card-body">
                                    <div className="custom-control custom-switch">
                                        <input type="checkbox" className="custom-control-input" id="opened" onChange={onChangeOpened} checked={opened}/>
                                        <label className="custom-control-label" htmlFor="opened">공개</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6" id="accordionTag">
                            {surveyList.map((survey, i) => (
                                <div className="card" key={i}>
                                    <div className="card-header contentColor">
                                        <button  className="btn p-0" type="button" data-toggle="collapse" data-target={"#collapse"+i} aria-expanded="true" aria-controls={"collapse"+i} onClick={() => surveyNumberCheck(i)}>
                                            <h3 className="card-title">{survey.question || "알수 없음"}</h3>
                                        </button>
                                        <button  className="btn p-0 float-right" type="button" onClick={() => surveyDelete(i)}>
                                            <i className="fas fa-trash-alt text-black-50" />
                                        </button>
                                    </div>
                                    <div className="card-body collapse"  id={"collapse"+i} aria-labelledby={"heading"+i} data-parent="#accordionTag">
                                        <div className="d-flex">
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">질문</h3>
                                                        <input type="text" className="form-control" placeholder="질문을 입력하세요.." value={survey.question} onChange={(e) => questionChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">대답유형</h3>
                                                        <select  className="form-control" onChange={(e) => answerTypeChange(i, e.target.value)} value={survey.answerType}> 
                                                            <option value="SELECTION">SELECTION</option>
                                                            <option value="TEXT">TEXT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                
                                                {
                                                    survey.answerType === "SELECTION" 
                                                    ? (
                                                        <div>
                                                            <div className="card">
                                                                <div className="card-body">
                                                                    <h3 className="card-title">선택타입</h3>
                                                                    <select  className="form-control" onChange={(e) => selectionTypeChange(i, e.target.value)} value={survey.selectionType}>
                                                                        <option value="SINGLE">SINGLE</option>
                                                                        <option value="MULTIPLE">MULTIPLE</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="card">
                                                            <div>
                                                                <div className="m-3 float-left">
                                                                    <h3 className="mt-1 card-title"> 태그 추가</h3>
                                                                    <input className="ml-2" type="checkbox" onClick={relatedTagCheckChange} checked={relatedTagCheck}/>
                                                                </div>
                                                                <button  className="btn float-right mt-2" type="button" onClick={(e) => answerAdd(i)}>
                                                                    <h3 className="card-title"><i className="fas fa-plus mr-1"></i> 보기 추가</h3>
                                                                </button>
                                                            </div>
                                                            <div className="card-body pt-1">
                                                                {survey.items.map((item, j) => (
                                                                    <div className="mb-2" key={j}>
                                                                        <div className="d-flex margin-top col-12 p-0">
                                                                            <input type="text" className="w-75 form-control" id="title11" placeholder="보기를 입력하세요.." value={item.body} onChange={(e) => answerChange(i, j, e.target.value)} />
                                                                            <buttom className="btn btn-default btn-primary ml-2 p-1" onClick={(e) => answerdelete(i, j)}>삭제</buttom>
                                                                        </div>
                                                                        <div className={relatedTagCheckCss}>
                                                                            {/* <TagBox title="태그" readCheck={false} tags={item.tags} callbackDeleteTag={callbackDeleteTag}></TagBox> */}
                                                                            <ReactTags id="keywordTag"
                                                                                tags={item.relatedTags}
                                                                                placeholder='태그'
                                                                                handleDelete={(e) => itemDeleteTag(i, j, e)}
                                                                                handleAddition={(e) => itemAddTag(i, j, e)}
                                                                                autofocus={false}
                                                                                readOnly={false}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                    : (
                                                        <div></div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="button-wrapper mb-5 col-12">
                            <button onClick={preViewSurvey} type="button" className="btn btn-primary mr-1" data-toggle="modal" data-target="#surveyModal"><i className="fas fas fa-search"></i> 미리보기</button>
                            <button onClick={updateSurvey} type="button" className="btn btn-primary mr-1"><i className="fas fa-plus"></i> 설문 수정하기</button>
                            <button onClick={deleteSurvey} type="button" className="btn btn-danger  mr-1"><i className="fas fa-trash-alt"></i> 삭제</button>
                            <button onClick={goList} type="button" className="btn btn-primary"><i className="fas fa-list"></i> 목록</button>
                        </div>
                    </div>
                </section>
             </div>
            {/* 모달 */}
            <SurveyModal surveyList={sendData} callbackSurveySendData={callbackSurveySendData}></SurveyModal>
        </div>
    );
}